module.exports = __webpack_public_path__ + "img/zgdj.92f2bb69.png";